export default function activeNames(isActive, name, styleObject) {
  if (isActive) return `${styleObject[name]} ${styleObject[`${name}--active`]}`;
  return styleObject[name];
}
